import React from 'react'
import Global from 'src/components/GlobalCSS'
import styled from '@emotion/styled'
import PartnerHeader from 'src/components/organisms/partner/PartnerHeader'
import SEO from 'src/components/seo'
import { PartnerFirstView } from 'src/components/organisms/partner/PartnerFirstView'
import { PartnerClient } from 'src/components/organisms/partner/PartnerClient'
import TopAbout from 'src/components/organisms/top/TopAbout'
import { PartnerVideo } from 'src/components/organisms/partner/PartnerVideo'
import { PartnerAdvantage } from 'src/components/organisms/partner/PartnerAdvantage'
import { PartnerAbout } from 'src/components/organisms/partner/PartnerAbout'
import { PartnerSupport } from 'src/components/organisms/partner/PartnerSupport'
import { PartnerHowto } from 'src/components/organisms/partner/PartnerHowto'
import { PartnerInfo } from 'src/components/organisms/partner/PartnerInfo'

class Partner extends React.Component {
    render() {
        return (
        <>
            <SEO
            title="販売代理店・販売パートナー募集"
            description="commmune(コミューン)を運営する、コミューン株式会社の販売代理店・販売パートナー募集ページです。"
            />
            <Global />
            <PartnerHeader />
            <PartnerFirstView/>
            <PartnerClient />
            <TopAbout />
            <PartnerVideo />
            <PartnerAdvantage />
            <PartnerAbout />
            <PartnerSupport />
            <PartnerHowto />
            <a id="info"></a>
            <PartnerInfo />
        </>
        )
    }
}



export default Partner

